"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDateValue = exports.getAgeFromSSN = exports.containsUpperCase = exports.containsSpecialChars = exports.containsNumber = exports.containsLowerCase = exports.containsGiven = exports.buildDatePickerValueProps = void 0;
var _dateFns = require("date-fns");
var buildDatePickerValueProps = function buildDatePickerValueProps(value) {
  var selected = undefined;
  var startDate = undefined;
  var endDate = undefined;
  if (typeof value === "string" && value.length > 0) {
    if (value.includes("~")) {
      var dates = value.split("~");
      startDate = dates[0].length > 0 ? (0, _dateFns.parseISO)(dates[0]) : undefined;
      endDate = dates[1].length > 0 ? (0, _dateFns.parseISO)(dates[1]) : undefined;
      selected = startDate;
    } else {
      selected = (0, _dateFns.parseISO)(value);
    }
  }
  return {
    selected: selected,
    startDate: startDate,
    endDate: endDate
  };
};
exports.buildDatePickerValueProps = buildDatePickerValueProps;
var getDateValue = function getDateValue(date) {
  var value;
  if (Array.isArray(date)) {
    if (date.length === 2 && (date[0] instanceof Date || date[0] === undefined || date[1] instanceof Date || date[1] === undefined)) {
      value = date.map(function (dateObj) {
        return dateObj instanceof Date ? dateObj.toISOString() : "";
      }).join("~");
    } else if (typeof date[1] === "string") {
      value = date[1];
    }
  } else if (date instanceof Date) {
    value = date.toISOString();
  }
  return value;
};
exports.getDateValue = getDateValue;
var getAgeFromSSN = function getAgeFromSSN(ssn) {
  var regExp = /^(\d{4})(\d{2})(\d{2})/;
  var matchResults = ssn.match(regExp);
  if (!(matchResults === null || matchResults === void 0 ? void 0 : matchResults[1]) || !(matchResults === null || matchResults === void 0 ? void 0 : matchResults[2]) || !(matchResults === null || matchResults === void 0 ? void 0 : matchResults[3])) {
    return undefined;
  }
  var date = (0, _dateFns.parseISO)("".concat(matchResults[1], "-").concat(matchResults[2], "-").concat(matchResults[3]));
  var diff = Date.now() - Number(date);
  var diffDate = new Date(diff);
  return Math.abs(diffDate.getUTCFullYear() - 1970);
};
exports.getAgeFromSSN = getAgeFromSSN;
var containsLowerCase = function containsLowerCase(text) {
  return Boolean(text.match(/[a-z]/gm));
};
exports.containsLowerCase = containsLowerCase;
var containsUpperCase = function containsUpperCase(text) {
  return Boolean(text.match(/[A-Z]/gm));
};
exports.containsUpperCase = containsUpperCase;
var containsNumber = function containsNumber(text) {
  return Boolean(text.match(/[0-9]/gm));
};
exports.containsNumber = containsNumber;
var containsSpecialChars = function containsSpecialChars(text) {
  return Boolean(text.match(/[^a-zA-Z0-9]/gm));
};
exports.containsSpecialChars = containsSpecialChars;
var containsGiven = function containsGiven(text, search) {
  return search.some(function (searchItem) {
    return text.includes(searchItem);
  });
};
exports.containsGiven = containsGiven;